import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
const MODULES = [{
  number: '01',
  title: 'Configuraciones esenciales',
  summary: 'Qué activar y qué desactivar, pantalla de inicio, Face ID y bloqueo.'
}, {
  number: '02',
  title: 'Batería y rendimiento',
  summary: 'Por qué se drena rápido y cómo hacer que dure muchas más horas.'
}, {
  number: '03',
  title: 'Funciones ocultas y trucos',
  summary: 'Gestos, atajos, escanear documentos y copiar texto desde fotos.'
}, {
  number: '04',
  title: 'Herramientas Apple',
  summary: 'iCloud, AirDrop, Siri, Atajos, Notas, Recordatorios y Fotos.'
}, {
  number: '05',
  title: 'Cámara, fotos y video',
  summary: 'Modo retrato y noche, luz, composición y edición desde el iPhone.'
}, {
  number: '06',
  title: 'Privacidad y seguridad',
  summary: 'Permisos de apps, contraseñas, ubicación y datos personales.'
}];
export function Curriculum() {
  return <Section className="bg-ink-900" data-id="element-109" data-mp="3guyux9p4fip4">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-110" data-mp="3gw0a9qd66rcn">El contenido</p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-111" data-mp="1nf5jigoidq5s">
        Qué encontrás dentro de Diccionario Apple
      </h2>
      <ul className="mt-8 grid gap-2.5 md:grid-cols-2" data-id="element-112" data-mp="1x835wxwmfz9o">
        {MODULES.map(module => <li key={module.number} className="flex gap-4 rounded-2xl border border-white/8 bg-ink-950 px-5 py-4" data-id="element-113" data-mp="1sftbb4kkab12">
            <span className="text-sm font-extrabold text-accent" data-id="element-114" data-mp="273xz2myh1cqp">{module.number}</span>
            <div data-id="element-115" data-mp="225mmw5kpeq5b">
              <p className="text-sm font-bold text-white sm:text-base" data-id="element-116" data-mp="2264tnw4zsmrh">{module.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-white/55 sm:text-sm" data-id="element-117" data-mp="2g5noxocpg3md">{module.summary}</p>
            </div>
          </li>)}
      </ul>
      <div className="mt-8" data-id="element-118" data-mp="lrmoiz1ib8k6">
        <CTAButton className="items-center" note="Acceso inmediato vía mail." data-id="element-119" data-mp="lsxriwn4oca8" />
      </div>
    </Section>;
}